/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import moment from "moment"


function SEO({ description, lang, meta, title, schema, productSchema, providerSchema, adsense }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `revised`,
          content: moment().format("YYYY-MM-DD"),
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      {schema.length > 0 &&
        <script type="application/ld+json">
          {schema}
        </script>
      }

      {productSchema.length > 0 &&
        <script type="application/ld+json">
          {productSchema}
        </script>
      }

      {providerSchema.length > 0 &&
        <script type="application/ld+json">
          {providerSchema}
        </script>
      }

      {adsense &&
        <script data-ad-client="ca-pub-9947304345279574" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
      }
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  description: ``,
  schema: ``,
  productSchema: ``,
  providerSchema: ``,
  adsense: true,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  schema: PropTypes.string,
  productSchema: PropTypes.string,
  providerSchema: PropTypes.string,
  adsense: PropTypes.bool,
}

export default SEO
